import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ReceivedNotification {
  id: number;
  dspId: number;
  notificationTypeId: number;
  title: string;
  recipient: string;
  senderName: string;
  senderAvatar: string;
  sender: string;
  createdBy: number;
  createdAt: string; // Use string if the date format is a string; otherwise, use Date
  expiryTime: string; // Use string if the date format is a string; otherwise, use Date
  status: number;
}

const initialState = {
  receivedNotifications: [] as ReceivedNotification[], // Existing notifications
  notificationQueue: [] as ReceivedNotification[], // New notification queue
};

export const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications: (state, action: PayloadAction<ReceivedNotification[]>) => {
      // Combine new notifications with existing ones
      state.receivedNotifications = [...state.receivedNotifications, ...action.payload];

      // Optional: Remove duplicates based on a unique identifier (e.g., Id)
      const uniqueNotifications = state.receivedNotifications.reduce((acc, notification) => {
        const existing = acc.find((n) => n.id === notification.id);
        return existing ? acc : [...acc, notification];
      }, [] as ReceivedNotification[]);

      state.receivedNotifications = uniqueNotifications;
    },
    pushNotification: (state, action: PayloadAction<ReceivedNotification[]>) => {
      state.notificationQueue = [...state.notificationQueue, ...action.payload];

      // Optional: Remove duplicates based on a unique identifier (e.g., Id)
      const uniqueNotifications = state.notificationQueue.reduce((acc, notification) => {
        const existing = acc.find((n) => n.id === notification.id);
        return existing ? acc : [...acc, notification];
      }, [] as ReceivedNotification[]);

      state.notificationQueue = uniqueNotifications;
    },
    popNotification: (state, action: PayloadAction<number>) => {
      const idToRemove = action.payload; // Get the id from the action payload

      // Check if queue is empty or id is provided
      if (state.receivedNotifications.length > 0 && idToRemove !== undefined) {
        state.receivedNotifications = state.receivedNotifications.filter(
          (notification) => notification.id !== idToRemove,
        ); // Filter out the item with matching Id
      }
    },
  },
});

export const { setNotifications, pushNotification, popNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
